export const generalConstants = {
  pageNumber: 900
}

export const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;